<template>
  <div v-if="visible" class="modal-overlay" @click.self="emit('close')">
    <div class="modal-content">
      <h3>{{ job.code }} - {{ translateStatus(job.status) }}</h3>

      <p><strong>{{ t('customer') }}:</strong> {{ job.user_name }} {{ job.user_surname }}</p>
      <p><strong>{{ t('email') }}:</strong> {{ job.user_email }}</p>
      <p><strong>{{ t('desc') }}:</strong> {{ job.description || t('none') }}</p>
      <p><strong>{{ t('languages') }}:</strong> {{ job.source_lang }} → {{ job.target_lang }}</p>
      <p v-if="job.translation_type"><strong>{{ t('translationType') }}:</strong> {{ job.translation_type }}</p>
      <p v-if="job.hat_tur_name"><strong>{{ t('hatType') }}:</strong> {{ job.hat_tur_name }}</p>

      <p v-if="job.file_name">
        <strong>{{ t('file') }}:</strong>
        <a :href="`${baseUrl}/uploads/${encodeURIComponent(job.file_name)}`" target="_blank">
          {{ extractOriginalFileName(job.file_name) }}
        </a>
      </p>

      <div>
        <strong>{{ t('outputs') }}:</strong>
        <template v-if="job.output_files && job.output_files.length">
          <ul>
            <li v-for="(file, index) in job.output_files" :key="index">
              <a :href="`${baseUrl}/uploads/output/${file}`" target="_blank">
                {{ extractOriginalFileName(file) }}
              </a>
            </li>
          </ul>
        </template>
        <span v-else>{{ t('none') }}</span>
      </div>

      <p v-if="job.output_upload_date">
        <strong>{{ t('uploadTime') }}:</strong> {{ formatDate(job.output_upload_date) }}
      </p>

      <p>
        <strong>{{ t('payment') }}:</strong>
        <span :style="{ color: job.is_paid ? 'green' : 'red' }">
          {{ job.is_paid ? t('paid') : t('pending') }}
        </span>
      </p>

      <button @click="emit('close')" class="btn">{{ t('close') }}</button>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const baseUrl = process.env.VUE_APP_API_URL
const props = defineProps({
  job: Object,
  visible: Boolean
})
const emit = defineEmits(['close'])
function extractOriginalFileName(filename) {
  return filename?.replace(/^\d+-\d+-/, '') || filename
}

function formatDate(dateStr) {
  if (!dateStr) return ''
  const d = new Date(dateStr)
  return `${d.getDate().toString().padStart(2, '0')}.${(d.getMonth() + 1).toString().padStart(2, '0')}.${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`
}

function translateStatus(status) {
  const map = {
    waiting: t('status.waiting'),
    in_progress: t('status.inProgress'),
    completed: t('status.completed'),
    assigned: t('status.assigned'),
    waiting_payment: t('status.waitingForPayment')
  }
  return map[status] || status
}

</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex; align-items: center; justify-content: center;
  z-index: 9999;
}
.modal-content {
  background: white;
  padding: 30px;
  border-radius: 8px;
  max-width: 600px;
  width: 95%;
  color: #222; /* Yazı rengi siyaha yakın */
}
.btn {
  background: #3498db;
  color: white; /* düzeltilmiş */
  border: none;
  padding: 10px 14px;
  border-radius: 6px;
  margin-top: 20px;
  cursor: pointer;
}
@media (max-width: 600px) {
  .modal-content {
    padding: 20px;
    width: 95%;
    font-size: 14px;
    line-height: 1.4;
  }

  .modal-content h3 {
    font-size: 18px;
    margin-bottom: 16px;
  }

  .modal-content p {
    margin-bottom: 10px;
  }

  .btn {
    width: 100%;
    font-size: 15px;
    padding: 12px;
  }
}

</style>
